import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CancelSubscriptionRequest, IEnterpriseUpgradeModalForm, ISubscription } from '../../Types/subcription';
import { AppSettings } from '../../Utils/Settings';

export const subscriptionApi = createApi({
    reducerPath: 'subscriptionApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        prepareHeaders: async (headers, {getState}) =>{
            headers.set(
                'Authorization',
                `Bearer ${(localStorage.getItem('token') ?? '')}`
            );
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getSubscriptions: builder.query<ISubscription[], void>({
            query: () => ({
                url: '/subscriptions',
                method: "GET"
            })
        }),
        updateSubscription: builder.mutation<any, {locator: string, body: {type: string, tier: string}}>({
            query: ({locator, body}) => ({
                url: `/subscriptions/update/${locator}`,
                method: "PUT",
                body
            })
        }),
        cancelSubscription: builder.mutation<any, CancelSubscriptionRequest>({
            query: ({locator, body}) => ({
                url: `/subscriptions/cancel/${locator}`,
                method: "PUT",
                body
            })
        }),
        reactivateSubscription: builder.mutation<any, string>({
            query: (locator) => ({
                url: `/subscriptions/reactivate/${locator}`,
                method: "PUT"
            })
        }),
        enterpriseRequest: builder.mutation<void, IEnterpriseUpgradeModalForm>({
            query: (body) => ({
                url: `/subscriptions/enterprise`,
                method: "POST",
                body
            })
        }),
    }),
})

export const {
    useGetSubscriptionsQuery,
    useUpdateSubscriptionMutation,
    useCancelSubscriptionMutation,
    useEnterpriseRequestMutation,
    useReactivateSubscriptionMutation
} = subscriptionApi